module.exports = __webpack_public_path__ + "img/dotMemory_icon.6f976856.png";